type State = {
  location: {
    hash: string;
    host: string;
    hostname: string;
    href: string;
    origin: string;
    pathname: string;
    port: string;
    protocol: string;
    search: string;
  };
  payload: object;
};

const STATE_KEY = `${process.env.REACT_APP_STORAGE_NAMESPACE}_auth.state`;

const clear = () => {
  sessionStorage.removeItem(STATE_KEY);
};

const getAndDestroy = (): State | null => {
  const stateJson = sessionStorage.getItem(STATE_KEY);

  if (!stateJson) {
    return null;
  }

  sessionStorage.removeItem(STATE_KEY);

  return JSON.parse(stateJson);
};

const save = ({
  location = globalThis.location,
  payload = {},
}: {
  location?: Location;
  payload?: any;
} = {}): void => {
  const state: State = {
    location: {
      hash: location.hash,
      host: location.host,
      hostname: location.hostname,
      href: location.href,
      origin: location.origin,
      pathname: location.pathname,
      port: location.port,
      protocol: location.protocol,
      search: location.search,
    },
    payload,
  };
  sessionStorage.setItem(STATE_KEY, JSON.stringify(state));
};

const AuthStateStorage = {
  getAndDestroy,
  save,
  clear,
};

export default AuthStateStorage;
